import script from "./VSModalDetalle.vue?vue&type=script&setup=true&lang=js"
export * from "./VSModalDetalle.vue?vue&type=script&setup=true&lang=js"

import "./VSModalDetalle.vue?vue&type=style&index=0&id=6447a4ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6447a4ae"]])

export default __exports__